import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Switch, Route, Link, useLocation } from "react-router-dom";
import "./../styles/Contact.scss";
import Api from "../common/api";

const Contact = () => {
  const [banner, setBanner] = useState([]);
  const [activePath, setActivePath] = useState(
    useLocation().pathname.split("/")[2]
  );

  const [Paths, setPaths] = useState(useLocation().pathname.split("/"));

  React.useEffect(() => {
    Api.get("/home/getmenu?slug=iletisim").then((res) => {
      setBanner(res.data.banner);
    });
  }, [activePath]);

  return (
    <>
      <header
        className="contact-header"
        style={{
          backgroundImage:
            `url("https://sankoenerji.com.tr` + banner + `")`,
        }}
      ></header>
      <div className="contact-container">
        <div className="breadcrumbz container-sm ">
          <ol>
            <li>
              <Link to="/en">
                Home Page <span>&gt;</span>
              </Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ol>
        </div>
        <div className="contact-content container-sm">
          <div className="content-left">
            <h3 className="header-three">Corporate Office </h3>
            <div className="first-para">
              <p className="blue">
                <a
                  href="https://www.google.com/maps/place/SANKO+HOLD%C4%B0NG/@41.0146255,28.8578001,13z/data=!4m18!1m12!4m11!1m3!2m2!1d28.8121382!2d41.0391013!1m6!1m2!1s0x14caa455189aa39b:0x3a1897091753c3ec!2zU0FOS08gSE9MRMSwTkcgMzQyMTIgQmHEn2PEsWxhci_EsHN0YW5idWw!2m2!1d28.811575!2d41.0391826!3m4!1s0x14caa455189aa39b:0x3a1897091753c3ec!8m2!3d41.0391826!4d28.811575"
                  target="_blank"
                >
                  <span>
                    <i className="fas fa-map-marker-alt"></i>
                  </span>{" "}
                  Address
                </a>
              </p>
              <p>
                15 Temmuz Mah. Gülbahar Cad. No:43 K: 6-7 34212 Güneşli/İstanbul
              </p>
            </div>
            <div className="second-para">
              <p className="blue">
                <span>
                  <i className="fas fa-phone-alt"></i>
                </span>{" "}
                Phone
              </p>
              <p>+90 444 87 65</p>
            </div>
            <div className="third-para">
              <p className="blue">
                <span>
                  <i className="fas fa-fax"></i>
                </span>{" "}
                Fax
              </p>
              <p>+90 212 410 46 66</p>
            </div>
          </div>
          <div className="content-right">
            <h3 className="header-three">Trade Registry </h3>
            <div className="center-div">
              <div className="first-para">
                <p className="blue">
                  <a href="https://www.google.com/maps/place/Burak,+Sani+Konuko%C4%9Flu+Blv.+No:223,+27580+%C5%9Eehitkamil%2FGaziantep/@37.0911192,37.4293159,15.76z/data=!4m5!3m4!1s0x1531e5a8a1befaef:0xccb6e3e9455ecefc!8m2!3d37.0903244!4d37.4358275"
                    target="_blank">
                    <span>
                      <i className="fas fa-map-marker-alt"></i>
                    </span>{" "}
                    Address
                  </a>
                </p>
                <p>
                  İbrahimli Mahallesi, Sanko Sokak, Sanko Holding Yönetim Binası, A Blok No: 12/A, 27560 Şehitkamil, Gaziantep
                </p>
              </div>
              <div className="second-para">
                <p className="blue">
                  <span>
                    <i className="fas fa-phone-alt"></i>
                  </span>{" "}
                  Phone
                </p>
                <p>+90 342 211 30 00</p>
              </div>
              {/* <div className="third-para">
                <p className="blue">
                  <span>
                    <i className="fas fa-fax"></i>
                  </span>{" "}
                  Fax
                </p>
                <p>+90 342 211 37 27</p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
